<template>
  <teleport to="#overlay">
    <div
      class="m-image-lightbox"
      @click="$emit('close')"
    >
      <div class="_actions">
        <m-btn
          class="_download"
          icon="download"
          icon-size="20"
          :icon-color="$colors.shades.white"
          force-icon-color
          fab
          :href="src"
          :download="fileName"
          @click.stop
        />
        <m-btn
          class="_close"
          icon="close"
          icon-size="20"
          :icon-color="$colors.shades.white"
          force-icon-color
          fab
          @click="$emit('close')"
        />
      </div>
      <img
        class="_image"
        :src="src"
        :alt="alt"
        @click.stop
      >
    </div>
  </teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted } from 'vue';

defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  fileName: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close']);

// whatever opened the picture usually closes on escape as well, and one key press must
// not dismiss both: capturing takes the key before it reaches anything underneath
const closeOnEscape = (event) => {
  if (event.key !== 'Escape') {
    return;
  }

  event.stopPropagation();
  emit('close');
};

onMounted(() => window.addEventListener('keydown', closeOnEscape, true));
onBeforeUnmount(() => window.removeEventListener('keydown', closeOnEscape, true));
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .m-image-lightbox {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6.4rem;
    cursor: zoom-out;
    background-color: rgb(0 0 0 / 40%);

    // whatever size it is, only shrunk when it would not otherwise fit
    ._image {
      display: block;
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 100%;
      cursor: default;
      object-fit: contain;
    }

    ._actions {
      position: fixed;
      top: 1.6rem;
      right: 1.6rem;
      display: flex;
      gap: .8rem;
    }

    ._download,
    ._close {
      background-color: rgb(0 0 0 / 40%);

      &:hover,
      &:focus-visible {
        background-color: rgb(0 0 0 / 60%);
      }
    }
  }
</style>
